import i18next from 'i18next';

export function setLanguage(lang) {
    i18next.changeLanguage(lang, (err, t) => {
        if (err) return console.log('something went wrong loading', err);
        t('key'); // -> same as i18next.t
    });
}